import { useContext, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import {
  getHasRetrievedSharedReportsSelector,
  getIsBackgroundReportUnavailableSelector,
} from '../../../../../../../selectors/sharedReports';
import { IcraaComplianceContext } from '../../../../../../../contexts/IcraaComplianceContext';
import { updateReportsLoadingStatuses } from '../../../../../../../actions/loadingStatusActionCreators';

function BackgroundCheckNavigation({ applicantId, customNavigationCallback, setCustomNavigationCallback }) {
  const dispatch = useDispatch();
  const hasRetrievedSharedReports = useSelector(getHasRetrievedSharedReportsSelector(applicantId));
  const isBackgroundReportUnavailable = useSelector(getIsBackgroundReportUnavailableSelector(applicantId));
  const { icraaAcceptedForApplicant } = useContext(IcraaComplianceContext);

  useEffect(() => {
    if (customNavigationCallback) {
      if (hasRetrievedSharedReports && icraaAcceptedForApplicant) {
        dispatch(updateReportsLoadingStatuses({ backgroundReportLoading: false }));
        setCustomNavigationCallback(null);

        /**
         * Navigation to report if report is available. If not, an
         * error alert gets shown.
         */
        if (!isBackgroundReportUnavailable) {
          customNavigationCallback();
        }
      } else {
        // We're waiting for shared reports, so disable view button.
        dispatch(updateReportsLoadingStatuses({ backgroundReportLoading: true }));
      }
    }
  }, [
    customNavigationCallback,
    hasRetrievedSharedReports,
    isBackgroundReportUnavailable,
    setCustomNavigationCallback,
    icraaAcceptedForApplicant,
    dispatch,
  ]);

  return null;
}

BackgroundCheckNavigation.propTypes = {
  applicantId: PropTypes.string.isRequired,
  customNavigationCallback: PropTypes.func,
  setCustomNavigationCallback: PropTypes.func.isRequired,
};

export default BackgroundCheckNavigation;
